export function updateAnalyticsConsent(allowed) {
    window.gtag?.('consent', 'update', {
        analytics_storage: allowed ? 'granted' : 'denied',
        ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied',
    });
}
